import { createTheme } from "@material-ui/core";

import { hexToRgba } from "utils/colors";

import {
  appPrimaryColor,
  appSecondaryColor,
  COLORS,
} from "constants/colorScheme";

export const DEFAULT_THEME = createTheme({
  spacing: 4,
  palette: {
    primary: {
      ...appPrimaryColor,
    },
    secondary: { ...appSecondaryColor },
    text: { primary: COLORS.FONT_DARK },
  },
  typography: {
    fontFamily: "Roboto",
    h1: {
      fontSize: 28,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "32px",
      letterSpacing: "0.5px",
    },
    h2: {
      fontSize: 24,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "26px",
      letterSpacing: "0.5px",
    },
    h3: {
      fontSize: 20,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "22px",
      letterSpacing: "0.5px",
    },
    h4: {
      fontSize: 16,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "24px",
    },
    subtitle1: {
      fontSize: 16,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "24px",
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "24px",
    },
    body1: {
      fontSize: 16,
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: 14,
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.29,
    },
    button: {
      fontSize: 14,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "20px",
    },
    caption: {
      opacity: 0.4,
      fontSize: 16,
      fontWeight: 500,
    },
  },
  overrides: {
    MuiAppBar: { root: { zIndex: 900 } },

    MuiButton: {
      root: {
        borderRadius: "4px",
        padding: "8px 16px",
        textTransform: "none",
        minHeight: "36px",
      },

      contained: {
        boxShadow: undefined,

        "&:hover": {
          boxShadow: undefined,
        },
      },

      containedPrimary: {
        "&:not(:disabled):hover": {
          backgroundColor: hexToRgba(COLORS.CYAN, 0.8),
          color: COLORS.WHITE,
        },

        "&:disabled": {
          backgroundColor: hexToRgba(COLORS.CYAN, 0.4),
          color: COLORS.WHITE,
        },
      },

      containedSecondary: {
        color: COLORS.CYAN,
        backgroundColor: COLORS.WHITE,

        "&:not(:disabled):hover": {
          backgroundColor: hexToRgba(COLORS.WHITE, 0.8),
          color: COLORS.CYAN,
        },

        "&:disabled": {
          backgroundColor: hexToRgba(COLORS.WHITE, 0.4),
          color: COLORS.CYAN,
        },
      },

      outlinedPrimary: {
        border: `2px solid ${COLORS.CYAN}`,
        backgroundColor: "transparent",

        "&:not(:disabled):hover": {
          borderColor: `${hexToRgba(COLORS.CYAN, 0.8)}`,
          borderWidth: "2px",
          backgroundColor: hexToRgba(COLORS.CYAN, 0.8),
          color: COLORS.WHITE,
        },

        "&:disabled": {
          border: "2px solid",
          backgroundColor: hexToRgba(COLORS.CYAN, 0.4),
          color: COLORS.WHITE,
        },
      },

      text: {
        backgroundColor: "transparent",

        "&:not(:disabled):hover": {
          color: COLORS.CYAN,
          backgroundColor: "transparent",
        },

        "&:disabled": {
          color: COLORS.BLACK_50,
          opacity: 0.4,
        },
      },
    },

    MuiFormControl: { root: { margin: undefined } },

    MuiFormControlLabel: { root: { minHeight: "38px", marginRight: "40px" } },

    MuiFormLabel: { root: { "&$error": { color: COLORS.RED } } },

    MuiOutlinedInput: {
      input: { padding: "17.5px 14px" },
    },

    MuiDivider: {
      root: { backgroundColor: COLORS.BLACK_25, margin: "32px 0" },
      light: { backgroundColor: COLORS.WHITE_20 },
    },

    MuiListSubheader: {
      root: {
        paddingBottom: "16px",
        color: COLORS.WHITE,
        fontSize: "20px",
        fontWeight: "normal",
        lineHeight: "23px",
      },
    },

    MuiListItem: {
      root: {
        marginTop: "8px",
        paddingTop: "4px",
        paddingBottom: "4px",
        borderRadius: "4px",
        color: COLORS.WHITE,
        "&$selected, &$selected:hover": {
          backgroundColor: hexToRgba(COLORS.CYAN_DARK, 0.2),
          color: COLORS.CYAN,
        },
        "&:hover": {
          color: COLORS.CYAN,
        },
        "&:not(:last-child)": {
          marginBottom: "8px",
        },
      },
    },

    MuiListItemIcon: { root: { color: undefined, minWidth: "40px" } },

    MuiFormHelperText: {
      root: {
        color: COLORS.RED,
        fontSize: "12px",
        lineHeight: "16px",
        opacity: 1,
        "&$error": { color: COLORS.RED },
        position: "absolute",
        bottom: "-18px",
      },
    },

    MuiPickerDTToolbar: { separator: { marginBottom: "8px" } },
  },
});
